var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.55,37.48H1.03c-0.1,0-0.17-0.1-0.13-0.19l11.04-26.97c0.02-0.05,0.07-0.09,0.13-0.09h1.83 c0.1,0,0.17,0.1,0.13,0.19L4.68,37.38C4.67,37.44,4.61,37.48,4.55,37.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M43.56,37.48h3.52c0.1,0,0.17-0.1,0.13-0.19L36.17,10.32c-0.02-0.05-0.07-0.09-0.13-0.09h-1.83 c-0.1,0-0.17,0.1-0.13,0.19l9.35,26.97C43.45,37.44,43.5,37.48,43.56,37.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.84,15.16l-0.14,4.52c0,0.08,0.06,0.15,0.14,0.15h2.44c0.08,0,0.14-0.07,0.14-0.15l-0.14-4.52 c0-0.08-0.06-0.14-0.14-0.14h-2.15C22.9,15.02,22.84,15.08,22.84,15.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.22,13.34l-0.09-2.98c0-0.08-0.06-0.14-0.14-0.14h-0.92h-0.92c-0.08,0-0.14,0.06-0.14,0.14l-0.09,2.98 c0,0.08,0.06,0.15,0.14,0.15h2.04C25.15,13.49,25.22,13.42,25.22,13.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.34,30.79l-0.21,6.54c0,0.08,0.06,0.15,0.14,0.15h1.78h1.78c0.08,0,0.14-0.07,0.14-0.15l-0.21-6.54 c0-0.08-0.06-0.14-0.14-0.14h-3.15C22.41,30.66,22.34,30.72,22.34,30.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.67,27.45l-0.17-5.22c0-0.08-0.06-0.14-0.14-0.14h-2.6c-0.08,0-0.14,0.06-0.14,0.14l-0.17,5.22 c0,0.08,0.06,0.15,0.14,0.15h2.94C25.6,27.59,25.67,27.53,25.67,27.45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50);
export default __webpack_public_path__ + "static/media/50.0f86164734a5679afaffeeb15888678a.svg";
export { ForwardRef as ReactComponent };